<template>
  <label
    class="BSCSwitch"
    :class="classType"
    ref="label"
    :disabled="disabled"
    @keydown.prevent.enter="$refs.label.click()"
    @mousedown="isMouseDown = true"
    @mouseup="isMouseDown = false"
    @mouseout="isMouseDown = false"
    @blur="isMouseDown = false"
  >
    <input
      class="BSCSwitch-input"
      v-model="value"
      type="checkbox"
      @click.stop
      :disabled="disabled"
      :name="name"
      :required="required"
      :true-value="trueValue"
      :false-value="falseValue"
    />
    <span
      class="BSCSwitch-check"
      :class="[
        { 'is-elastic': isMouseDown && !disabled },
        { 'BSCSwitch-check--is-active': value },
        type
      ]"
    />
  </label>
</template>

<script>
'use strict'

export default {
  name: 'BSCSwitch',
  emits: ['input'],
  props: {
    modelValue: [Boolean],
    disabled: Boolean,
    type: {
      type: String,
      default: 'normal'
    },
    name: String,
    required: Boolean,
    size: String,
    trueValue: {
      type: [String, Number, Boolean, Function, Object, Array, Symbol],
      default: true
    },
    falseValue: {
      type: [String, Number, Boolean, Function, Object, Array, Symbol],
      default: false
    }
  },
  data() {
    return {
      value: this.modelValue,
      isMouseDown: false
    }
  },
  computed: {
    classType() {
      return [this.size, { 'is-disabled': this.disabled }, `is-${this.type}`]
    }
  },
  watch: {
    value: {
      immediate: false,
      handler(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
